
export const getOfferUrl = {
  url: '//data.p4psearch.1688.com/data/ajax/get_premium_offer_list.json',
  type: 'jsonp'
};

const isPre = window.location.href.includes("pre-p4psearch.1688.com") || window.location.href.includes("preMode");

export const getGraphOfferUrl = {
  url: `//${isPre ? "pre-" : ""}p4psearch.1688.com/hamlet/async/v1.json`,
};

export const getSuggestKeywordList = {
  url: "//suggest.1688.com/bin/suggest?type=offer&encode=utf8",
  type: "jsonp"
}

export const getGuessKeywordList = {
  url: "//data.p4psearch.1688.com/data/ajax/search_guess_you_like.json",
  type: "jsonp"
}

export const getOfferPromotionList = {
  url: "//data.p4psearch.1688.com/data/ajax/search_offer_promotion_list.json",
  type: "jsonp"
}
